
export default function Selector(props: any) {
  return (
    <div style={{ padding: "0 5px 0 5px", maxHeight: "94vh", overflowY: "scroll", backgroundColor: "white", border: "solid grey 1px" }}>
      {Object.keys(props.chartInfo || {})
        .map((datasetId: string, datasetIndex: number) => (
          <div key={datasetIndex}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                cursor: "pointer",
                backgroundColor: props.selectedDatasetId === datasetId ? "lightblue" : "white",
                padding: "5px",
                borderBottom: "solid grey 1px"
              }}
              onClick={(e: any) => {
                props.onSelectDataset(datasetId);
              }}
            >
              {datasetId}
            </div>
          </div>
        ))}
    </div>
  )
}

